import React from "react";
import Typography from "@mui/material/Typography";

const ParaSubtitle = ({paraSubtitle}) => {
    return (
        <div>
            <Typography variant="h6" component="div" sx={{ py: '20px' }}>
                {paraSubtitle}
            </Typography>
        </div>
    );
};

export default ParaSubtitle;
